import { AnaColumn } from "../forms-template.service";

export const infoImpresa : AnaColumn[] = [
    {
      itemType: "group", groupDataField: 'InformazioniImpresa', caption: "Informazioni Impresa", colCount: "2", data: [
        /*
        {
          type: 'campo', dataField: "escludiPec", dataType: "boolean", caption: "Escludi PEC", editorType: "dxCheckBox", hideOnEdit: false
        },
        { type: 'empty', caption: '', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, colSpan: '1' },
        */

        { type: 'empty', caption: '', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, colSpan: '1' },

        { type: 'empty', caption: '', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, colSpan: '1' },
        {
          type: 'campo', colVisible: false, dataField: "ragione_Sociale", caption: "Ragione Sociale", hideOnEdit: false, disableOnUpdate: true, colSpan: '2', width: 540
        },
        {
          type: 'campo', colVisible: false, dataField: "indirizzo", caption: "Indirizzo", hideOnEdit: false, disableOnUpdate: true, width: 200
        },
        {
          type: 'campo', colVisible: false, dataField: "civico", caption: "Civico", hideOnEdit: false, disableOnUpdate: true, width: 200
        },
        {
          type: 'campo', colVisible: false, dataField: "localita", caption: "Località", hideOnEdit: false, disableOnUpdate: true, width: 200
        },
        {
          type: 'campo', colVisible: false, dataField: "cap", caption: "CAP", hideOnEdit: false, disableOnUpdate: true, width: 200
        },
        {
          type: 'campo', colVisible: false, dataField: "prov", caption: "Provincia", hideOnEdit: false, disableOnUpdate: true, width: 200
        },
        {
          type: 'campo', colVisible: false, dataField: "regione", caption: "Regione", hideOnEdit: false, disableOnUpdate: true, width: 200
        },
        {
          type: 'campo', colVisible: false, dataField: "vat", caption: "TAX (Cod. Fiscale)", hideOnEdit: false, disableOnUpdate: true, width: 200
        },
        {
          type: 'campo', colVisible: false, dataField: "tax", caption: "Partita IVA", hideOnEdit: false, disableOnUpdate: true, width: 200
        },
        {
          type: 'campo', colVisible: false, dataField: "crifnumber", caption: "Codice CRIF", hideOnEdit: false, disableOnUpdate: true, width: 200
        },
        {
          type: 'campo', colVisible: false, dataField: "statoattivita", caption: "Stato Attività", hideOnEdit: false, disableOnUpdate: true, width: 200
        },
        {
          type: 'campo', colVisible: false, dataField: "pec", caption: "PEC", hideOnEdit: false, disableOnUpdate: true, width: 540
        },
        { type: 'empty', caption: '', colVisible: false, dataField: '', dataType: "", hideOnEdit: false, colSpan: '1' },

      ]
    }
  ];